export interface CodeBlock {
  language: string;
  code: string;
}

export function extractCodeBlocks(text: string): CodeBlock[] {
  if (!text) return [];
  const blocks: CodeBlock[] = [];
  const regex = /```(\w+)?\n([\s\S]*?)```/g;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    blocks.push({
      language: match[1] || 'text',
      code: match[2].trim(),
    });
  }

  return blocks;
}

export function hasMarkdown(text: string): boolean {
  if (!text) return false;
  return /(\*\*|__|`|```|\[.*?\]\(.*?\)|^>|\n#{1,6}\s|^\s*[-*+]\s|^\s*\d+\.\s)/m.test(text);
}
